import { FormSpy, useForm } from 'react-final-form';

import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import styles from './FieldMark.module.scss';

interface IFieldMarkProps {
  fieldName?: string;
  label: string;
}

export const FieldMark = ({ fieldName, label }: IFieldMarkProps) => {
  const form = useForm();

  if (!fieldName) return null;

  const label_parts = label.split(' ');
  const label_last_word = label_parts.pop();

  return (
    <span>
      {label_parts.join(' ')}{' '}
      <span style={{ whiteSpace: 'nowrap' }}>
        {label_last_word}
        <FormSpy subscription={{ values: true, errors: true, touched: true }}>
          {({ errors }) => {
            const isShowRedMark = !!fieldName;

            if (errors) {
              // @ts-ignore
              const field = form.getFieldState(fieldName);
              const isError = typeof field?.error === 'string' || !!errors[fieldName];
              const isEmpty = !field?.value || (Array.isArray(field?.value) && !field?.value.length);

              if (fieldName && isShowRedMark && isError && (isEmpty || field?.error === REQUIRED_ERROR)) {
                return <span className={styles.RedMark}> *</span>;
              }
            }

            return null;
          }}
        </FormSpy>
      </span>
    </span>
  );
};
